import React from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { Link, useParams } from 'react-router-dom'

import EditGroupLearningAssignmentForm from '../../components/learningAssignmentForms/EditGroupLearningAssignmentForm/EditGroupLearningAssignmentForm'

import useRoutes from '../../state/useRoutes'

export default React.memo(function EditGroupLearningAssignmentPage() {
  const { uuid, learningItemUuid } = useParams()

  const { close } = useOutletContext<any>()

  return <EditGroupLearningAssignmentForm groupUuid={uuid!} learningItemUuid={learningItemUuid!} onClose={close} />
})

export function EditGroupLearningAssignmentPageBreadcrumb() {
  const { uuid, learningItemUuid } = useParams()
  const { t } = useTranslation()
  const routes = useRoutes()
  return (
    <Link to={routes.editGroupLearningAssignment.url({ uuid: uuid!, learningItemUuid: learningItemUuid! })}>
      {t('generic cta.edit')}
    </Link>
  )
}
